/* eslint-disable */
import boy1 from "../assets/svg/testimonials/boy1.svg";
import boy2 from "../assets/svg/testimonials/boy2.svg";
import boy3 from "../assets/svg/testimonials/boy3.svg";

export const testimonialsData = [
  {
    id: 1,
    name: "Abhijeet Kushwaha",
    title: "Founder - Sprilio Tech",
    text: "Gaurav consistently delivers outstanding results. His technical skills, combined with his problem-solving mindset, make him an invaluable asset to our team and projects.",
    image: boy2,
  },
  {
    id: 2,
    name: "Ashwani Pathak",
    title: "Co-Founder - Sprilio Tech",
    text: "Gaurav’s innovative approach and commitment to quality have set a new benchmark for project execution. He’s not just a developer but a visionary team player.",
    image: boy3,
  },
  {
    id: 3,
    name: "Arjun Rai",
    title: "Founder - Cognizn",
    text: "I was amazed by Gaurav’s attention to detail and his ability to adapt to our unique requirements. His work truly exceeded our expectations!",
    image: boy1,
  },
  {
    id: 4,
    name: "Jesse Linson",
    title: "Founder ",
    text: "The Bookvid platform wouldn’t be what it is today without Gaurav’s expertise. His ability to seamlessly integrate cutting-edge technologies has been a game changer for us.",
    image: boy2,
  },
  {
    id: 5,
    name: "Mohammad Suhail",
    title: "Freelancer ",
    text: "Gaurav has been instrumental in streamlining our data integration and e-commerce solutions. His expertise and dedication have significantly enhanced our workflow and donor engagement strategies. Truly a pleasure to work with!",
    image: boy3,
  },
];
